module.exports = __webpack_public_path__ + "img/arrow-top.c27ccd5a.svg";